export function getBusinessUrl() {
  return '';
}

export function getBusinessAuthRedirectUrl() {
  return '/';
}
